// 客户 id -> 姓名 全局缓存映射。后端列表 records 仅返回 customerId，不返回客户姓名，
// 列表页统一通过 loadCustomerMap 预加载后用 customerName(id) 展示。
let map = null

export async function loadCustomerMap (axios) {
  if (map) return map
  const r = await axios.get('/customers?page=1&limit=10000')
  const m = {}
  ;((r.data && r.data.data && r.data.data.records) || []).forEach(c => { m[c.id] = c.name })
  map = m
  return map
}

export function customerName (id) {
  if (!id || !map) return ''
  return map[id] || ''
}
